import { useState, useEffect } from 'react'
import { useAuth } from 'contexts/AuthContext'
import { useRouter } from 'next/router'

export const useLoginPage = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [splashLoading, setSplashLoading] = useState(false)
  const router = useRouter()
  const { login } = useAuth()

  useEffect(() => {
    localStorage?.setItem('email', email)
  }, [email])

  const handleSubmit = async (e, isAuthModal = false) => {
    e.preventDefault()
    setLoading(true)
    setError('')
    try {
      const userData = await login(email, password)

      if (userData.success && !userData.confirmed) {
        return router.push(`/verify-email/${email}`).catch((e) => {
          // workaround for https://github.com/vercel/next.js/issues/37362
          if (!e.cancelled) {
            throw e
          }
        })
      }

      if (!userData.onboardingCompletedAt) {
        return router.push('/onboarding')
      }

      if (isAuthModal) {
        // if is modal route to same page
        return router.reload()
      }
      setSplashLoading(true)
      await router.push('/dashboard')
    } catch (error) {
      const { response } = error
      setError(response.data.data)
      setLoading(false)
    }
  }

  const handleEmailChange = (e) => {
    setEmail(e.target.value)
  }

  const handlePasswordChange = (e) => {
    setPassword(e.target.value)
  }

  return {
    splashLoading,
    setSplashLoading,
    handleSubmit,
    handleEmailChange,
    handlePasswordChange,
    email,
    password,
    loading,
    error,
  }
}
